import { render, staticRenderFns } from "./DappDetailedStats.vue?vue&type=template&id=5fed8b2b&scoped=true"
import script from "./DappDetailedStats.vue?vue&type=script&lang=ts"
export * from "./DappDetailedStats.vue?vue&type=script&lang=ts"
import style0 from "./DappDetailedStats.vue?vue&type=style&index=0&id=5fed8b2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fed8b2b",
  null
  
)

export default component.exports